import { __rest, __assign } from 'tslib';
import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { NavigationBarPrivate } from '@alfalab/core-components-navigation-bar-private/esm';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';

var desktopStyles = {"content":"side-panel__content_s05pj","size-500":"side-panel__size-500_s05pj","sticky":"side-panel__sticky_s05pj"};
require('./desktop.css')

var styles = {"header":"side-panel__header_4lelc","hasContent":"side-panel__hasContent_4lelc","highlighted":"side-panel__highlighted_4lelc","sticky":"side-panel__sticky_4lelc","backgroundImage":"side-panel__backgroundImage_4lelc","content":"side-panel__content_4lelc","title":"side-panel__title_4lelc","addon":"side-panel__addon_4lelc","closer":"side-panel__closer_4lelc","right":"side-panel__right_4lelc","trim":"side-panel__trim_4lelc"};
require('./index.css')

var mobileStyles = {"header":"side-panel__header_mx7ox","sticky":"side-panel__sticky_mx7ox","content":"side-panel__content_mx7ox"};
require('./mobile.css')

var Header = function (_a) {
    var _b, _c;
    var className = _a.className, children = _a.children, contentClassName = _a.contentClassName, title = _a.title, sticky = _a.sticky, _d = _a.hasCloser, hasCloser = _d === void 0 ? true : _d, restProps = __rest(_a, ["className", "children", "contentClassName", "title", "sticky", "hasCloser"]);
    var _e = useContext(ModalContext), setHasHeader = _e.setHasHeader, headerHighlighted = _e.headerHighlighted, onClose = _e.onClose, componentRef = _e.componentRef;
    var _f = useContext(ResponsiveContext) || {}, _g = _f.size, size = _g === void 0 ? 500 : _g, _h = _f.view, view = _h === void 0 ? 'desktop' : _h, dataTestId = _f.dataTestId;
    useEffect(function () {
        setHasHeader(true);
    }, [setHasHeader]);
    var hasContent = Boolean(title || children);
    return (React.createElement(NavigationBarPrivate, __assign({ dataTestId: getDataTestId(dataTestId, 'header') }, restProps, { scrollableParentRef: componentRef, view: view, sticky: sticky, title: title, hasCloser: hasCloser, onClose: onClose, className: cn(styles.header, className, (_b = {},
            _b[styles.highlighted] = hasContent && sticky && headerHighlighted,
            _b[styles.sticky] = sticky,
            _b[styles.hasContent] = hasContent,
            _b[desktopStyles.sticky] = view === 'desktop' && sticky,
            _b[desktopStyles[SIZE_TO_CLASSNAME_MAP[size]]] = view === 'desktop',
            _b[mobileStyles.sticky] = view === 'mobile' && sticky,
            _b[mobileStyles.header] = view === 'mobile',
            _b)), contentClassName: cn(contentClassName, (_c = {},
            _c[desktopStyles.content] = view === 'desktop',
            _c[mobileStyles.content] = view === 'mobile',
            _c)) }), children));
};

export { Header };
